import * as React from "react";
import {
  Select,
  InputLabel,
  FormControl,
  createStyles,
  Theme,
  makeStyles,
  MenuItem,
} from "@material-ui/core";
import BaseFilter from "../../core/models/BaseFilter";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "minWidth": 125,
      "background": theme.palette.common.white,
      "margin": theme.spacing(0, 0.5),

      "& legend": {
        maxWidth: 0,
      },

      "& .MuiOutlinedInput-input": {
        padding: theme.spacing(1, 4, 1, 1),
      },

      // replace default size of select
      "& .MuiInputLabel-outlined": {
        transform: "translate(14px, 10px) scale(1)",
      },

      // refixes transition animation on select
      "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
        transform: "translate(0px, -12px) scale(0.75)",
        background: "transparent",
        borderTop: "unset",
      },

      // change background color on hover of native select option
      "& option:hover": {
        backgroundColor: theme.palette.primary.main,
      },
    },
  })
);

type MaterialSelectProps = {
  filter: BaseFilter;
  classes?: Record<"root", string>;
  disabled?: boolean;
};

function MaterialSelect(props: MaterialSelectProps) {
  const { value, handleChange, items, id, label, variant } = props.filter;
  const disabled = props.disabled ?? false;

  let classes = useStyles();

  if (props.classes) {
    classes = props.classes;
  }

  return (
    <FormControl className={classes.root} variant={variant || "outlined"}>
      <InputLabel id={`select-label-${id}-${label}`}>{label}</InputLabel>
      <Select
        labelId={`simple-select-label-${id}-${label}`}
        id={id}
        value={value}
        onChange={handleChange}
        label={label}
        disabled={disabled}
      >
        {items.map(({ key, value }) => (
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default MaterialSelect;
